import { mainSiteUrl } from '@/mocks/categories';

export default function SocialProof() {
  const stats = [
    { value: '10 000+', label: 'Użytkowników' },
    { value: '5+', label: 'Lat doświadczenia' },
    { value: '100+', label: 'Przeanalizowanych rozwiązań' },
    { value: '24/7', label: 'Dostępność' },
  ];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100/70 rounded-full mb-4">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-xs text-accent-600"></i>
            </div>
            <span className="text-xs font-medium text-accent-700">Zaufanie</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
            Ponad 10 000 użytkowników korzysta z podobnych rozwiązań
          </h2>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-14">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-3xl md:text-4xl text-primary-600 mb-1">{stat.value}</p>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              name: 'Anna Kowalska',
              username: '@anna_kowalska',
              text: 'usfansspreadsheet całkowicie zmienił sposób, w jaki zarządzam danymi. Intuicyjny interfejs i szybkość działania są niesamowite.',
              avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20woman%20with%20glasses%20against%20soft%20green%20backdrop%2C%20confident%20friendly%20smile%2C%20business%20portrait%20photography%2C%20clean%20and%20modern%20look%2C%20even%20studio%20lighting%2C%20corporate%20style&width=200&height=200&seq=avt-v2-01&orientation=squarish',
            },
            {
              name: 'Piotr Nowak',
              username: '@piotr_nowak',
              text: '"Porównałem wiele narzędzi i usfansspreadsheet jest zdecydowanie najlepszy pod względem organizacji danych i bezpieczeństwa."',
              avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20man%20with%20short%20beard%20against%20warm%20terracotta%20backdrop%2C%20slight%20smile%2C%20business%20portrait%20photography%2C%20modern%20style%2C%20even%20studio%20lighting%2C%20approachable%20expression&width=200&height=200&seq=avt-v2-02&orientation=squarish',
            },
            {
              name: 'Marta Wiśniewska',
              username: '@marta_wisniewska',
              text: '"Jako analityk danych polecam usfansspreadsheet każdemu, kto szuka prostego i skutecznego narzędzia do pracy z arkuszami."',
              avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20woman%20with%20short%20hair%20against%20light%20gray%20backdrop%2C%20warm%20smile%2C%20business%20portrait%20photography%2C%20confident%20look%2C%20soft%20studio%20lighting%2C%20modern%20corporate%20style&width=200&height=200&seq=avt-v2-03&orientation=squarish',
            },
            {
              name: 'Tomasz Lewandowski',
              username: '@tomasz_lew',
              text: '"Bezpieczeństwo danych było moim priorytetem. usfansspreadsheet spełnia wszystkie standardy RODO i daje mi spokój."',
              avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20man%20with%20dark%20hair%20against%20muted%20blue%20backdrop%2C%20friendly%20confident%20expression%2C%20business%20portrait%20photography%2C%20clean%20studio%20lighting%2C%20modern%20professional%20look&width=200&height=200&seq=avt-v2-04&orientation=squarish',
            },
            {
              name: 'Katarzyna Zielińska',
              username: '@kasia_zielinska',
              text: '"Aktualizacje usfansspreadsheet są regularne i zawsze dodają coś wartościowego. Widać, że zespół dba o użytkowników."',
              avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20woman%20with%20long%20hair%20against%20soft%20peach%20backdrop%2C%20bright%20smile%2C%20business%20portrait%20photography%2C%20warm%20studio%20lighting%2C%20friendly%20and%20professional%20look&width=200&height=200&seq=avt-v2-05&orientation=squarish',
            },
            {
              name: 'Michał Kaczmarek',
              username: '@michal_k',
              text: '"Przeszedłem z Excela na usfansspreadsheet i nie żałuję. Organizacja danych jest na zupełnie innym poziomie."',
              avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20man%20in%20suit%20against%20warm%20sand%20backdrop%2C%20confident%20professional%20smile%2C%20business%20portrait%20photography%2C%20clean%20studio%20lighting%2C%20executive%20style&width=200&height=200&seq=avt-v2-06&orientation=squarish',
            },
          ].map((testimonial, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl p-6 border border-background-200/60 hover:translate-y-[-1px] transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{testimonial.name}</p>
                  <p className="text-xs text-foreground-400">{testimonial.username}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{testimonial.text}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <span>Uzyskaj dostęp do pełnego rozwiązania</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}